(function () {
  'use strict';

  // To reset for testing: localStorage.removeItem('kb_nl_seen'); localStorage.removeItem('kb_nl_subscribed');

  var LS_SEEN        = 'kb_nl_seen';
  var LS_SUBSCRIBED  = 'kb_nl_subscribed';
  var KLAVIYO_CID    = 'Xs6W9W';
  var KLAVIYO_LIST   = 'Wa3QLb';
  var DELAY_MS       = 8000;

  console.log('Newsletter popup initialized');

  /* ── guard rails ── */

  function shouldSkip() {
    try {
      if (localStorage.getItem(LS_SEEN))       return true;
      if (localStorage.getItem(LS_SUBSCRIBED)) return true;
    } catch (_) {}

    var path = window.location.pathname;
    if (path === '/cart' || path.indexOf('/checkout') === 0) return true;

    return false;
  }

  function markSeen() {
    try { localStorage.setItem(LS_SEEN, '1'); } catch (_) {}
  }

  function markSubscribed() {
    try {
      localStorage.setItem(LS_SUBSCRIBED, '1');
      localStorage.setItem(LS_SEEN, '1');
    } catch (_) {}
  }

  /* ── DOM helpers ── */

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  /* ── build popup ── */

  function buildPopup() {
    var overlay = el('div', 'nl-overlay');

    var modal = el('div', 'nl-modal');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'nl-headline');

    // close button
    var closeBtn = el('button', 'nl-close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close newsletter popup');
    closeBtn.innerHTML = '&#x2715;';

    // brand label / logo
    var brand = el('p', 'nl-brand');
    if (window.kbLogoUrl) {
      var logoImg = document.createElement('img');
      logoImg.src = window.kbLogoUrl;
      logoImg.alt = 'KB Rides';
      logoImg.style.height = '40px';
      logoImg.style.width = 'auto';
      brand.appendChild(logoImg);
    } else {
      brand.textContent = 'KB RIDES';
    }

    // headline
    var headline = el('h2', 'nl-headline');
    headline.id = 'nl-headline';
    headline.textContent = 'Get 10% off your first order';

    // subtext
    var subtext = el('p', 'nl-subtext');
    subtext.textContent = 'Join the KB Rides community — new parts, builds, and exclusive deals straight to your inbox';

    // form
    var form = el('form', 'nl-form');
    form.noValidate = true;

    var emailInput = el('input', 'nl-email');
    emailInput.type = 'email';
    emailInput.placeholder = 'Your email address';
    emailInput.autocomplete = 'email';
    emailInput.required = true;

    var submitBtn = el('button', 'nl-submit');
    submitBtn.type = 'submit';
    submitBtn.textContent = 'Claim 10% off';

    var message = el('p', 'nl-message');
    message.setAttribute('aria-live', 'polite');

    form.appendChild(emailInput);
    form.appendChild(submitBtn);
    form.appendChild(message);

    // dismiss link
    var dismiss = el('button', 'nl-dismiss');
    dismiss.type = 'button';
    dismiss.textContent = "No thanks, I’ll pay full price";

    modal.appendChild(closeBtn);
    modal.appendChild(brand);
    modal.appendChild(headline);
    modal.appendChild(subtext);
    modal.appendChild(form);
    modal.appendChild(dismiss);

    return { overlay: overlay, modal: modal, emailInput: emailInput, submitBtn: submitBtn, message: message, closeBtn: closeBtn, dismiss: dismiss, form: form };
  }

  /* ── klaviyo submit ── */

  function subscribeEmail(email, submitBtn, message) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';
    message.textContent = '';
    message.className = 'nl-message';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_CID, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2023-12-15',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST,
              },
            },
          },
        },
      }),
    })
      .then(function (res) {
        if (res.ok || res.status === 202) {
          markSubscribed();
          message.textContent = 'You’re in! 🎉 Check your email for your 10% discount code';
          message.className = 'nl-message nl-message--success';
          submitBtn.style.display = 'none';
        } else {
          throw new Error('api error ' + res.status);
        }
      })
      .catch(function () {
        message.textContent = 'Something went wrong. Please try again.';
        message.className = 'nl-message nl-message--error';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Claim 10% off';
      });
  }

  /* ── popup lifecycle ── */

  function openPopup() {
    if (shouldSkip()) return;
    console.log('Newsletter popup showing');

    var parts = buildPopup();
    var overlay   = parts.overlay;
    var modal     = parts.modal;
    var emailInput = parts.emailInput;
    var submitBtn  = parts.submitBtn;
    var message    = parts.message;
    var closeBtn   = parts.closeBtn;
    var dismiss    = parts.dismiss;
    var form       = parts.form;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    // trigger enter animation after paint
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        overlay.classList.add('nl-overlay--visible');
        modal.classList.add('nl-modal--visible');
      });
    });

    function close() {
      markSeen();
      overlay.classList.remove('nl-overlay--visible');
      modal.classList.remove('nl-modal--visible');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () {
        overlay.remove();
        modal.remove();
      }, 350);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    dismiss.addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!email || !emailInput.checkValidity()) {
        message.textContent = 'Please enter a valid email address.';
        message.className = 'nl-message nl-message--error';
        return;
      }
      subscribeEmail(email, submitBtn, message);
    });
  }

  /* ── init ── */

  if (!shouldSkip()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(openPopup, DELAY_MS);
      });
    } else {
      setTimeout(openPopup, DELAY_MS);
    }
  }

})();
